var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'component--ribbon__button',
    `size-${_vm.size}`,
    _vm.disabled ? 'disabled' : null,
  ],attrs:{"title":_vm.titleText},on:{"mouseenter":function($event){_vm.isHover = true},"mouseleave":function($event){_vm.isHover = false},"mousedown":_vm.handleRootMouseDown,"click":_vm.handleRootClick}},[_c('div',{class:['ribbon-button__image', 'flex-center', _vm.iconClass]},[(!!_vm.icon && _vm.icon.startsWith('el-'))?_c('i',{class:[_vm.icon, 'ribbon-button__image-icon']}):(
        !!_vm.icon && (_vm.icon.startsWith('fa:') || _vm.icon.startsWith('far:'))
      )?_c('fa-icon',{staticClass:"ribbon-button__image-icon",attrs:{"icon":[
        _vm.icon.substr(0, _vm.icon.indexOf(':')),
        _vm.icon.substr(_vm.icon.indexOf(':') + 1),
      ]}}):_vm._t("icon")],2),_c('div',{class:[
      'ribbon-button__text',
      _vm.size !== 'small' && _vm.showSplitLine && _vm.isHover ? 'with-border' : null,
    ]},[(_vm.$slots.label)?[_vm._t("label")]:[_c('div',{staticClass:"ribbon-button__text-label"},[_vm._v("\n        "+_vm._s(_vm.labelText)+"\n      ")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }